import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { Injectable, signal } from '@angular/core';
import { AuthService } from '@libs/app.services/landing/auth.service';
import { ISignProvider, ITokens } from '@libs/interfaces';
import { MapResponseData } from '@libs/rxjs/operators.rxjs';
import { map, filter, tap, switchMap } from 'rxjs';
import { ApiService } from '@libs/app.services/api.service';
import { ConfigService } from '@libs/app.services/landing/config.service';
import { LocalstorageService } from '@libs/app.services/landing/localstorage.service';
import { DeviceService } from '../device.service';
@Injectable({
  providedIn: 'root',
})
export class SignProvidersService {
  loading = signal(false);
  constructor(
    private socialAuthService: SocialAuthService,
    private auth: AuthService,
    private apiService: ApiService,
    private ls: LocalstorageService,
    private config: ConfigService,
    private deviceService: DeviceService,
  ) {}

  /**
   * Get the authentication state of the social providers.
   * @returns {Observable<ISignProvider>} An observable containing the authentication state of the social providers.
   */
  providers() {
    return this.socialAuthService.authState.pipe(
      map((user: SocialUser) => user as ISignProvider),
      filter(Boolean),
      switchMap((user: ISignProvider) => this.trySignWithProvider(user)),
    );
  }

  /**
   * Try to sign in with the provided social user.
   * @param {ISignProvider} user - The social user to sign in with.
   */
  private trySignWithProvider(user: ISignProvider) {
    this.loading.set(true);
    return this.apiService
      .post('auth/trySignWithProvider', { ...user, provider: this.deviceService.telegramUser() })
      .pipe(
        MapResponseData,
        filter(({ error }) => !error),
        tap(() => this.ls.storeEmail(user.email)),
        tap((tokens: ITokens) => this.auth.storeTokens(tokens)),
        switchMap(() => this.config.init()),
        tap(() => this.loading.set(false)),
      );
  }
}
